import React from "react";
import type { ContextProps } from '../../types';
import {PageTitle} from "../../Components/Landmarks";
import {LayoutSmall} from "../../Components/Layout/";
import hero from "../../images/PageNotFound.png";
import {locations} from "../../Utilities/Location";
import {Link} from "../../Components/Link";

export const NotFoundContainer = ({
                                    header = "Page Not Found",
                                    message = "Something went wrong.",
                                }: ContextProps) => {

    return (
        <LayoutSmall className={`text-center`}>
            <PageTitle h1={header}/>
            {
                message &&
                <>
                    <p className="text-center">{message}</p>
                    <p>Please return <Link {...locations.LANDING.link} /> or view your <Link {...locations.DASHBOARD.link} />.</p>
                </>
            }
            <LayoutSmall className={`margin--all`}>
                <img src={hero} alt="Pages exploding through book cover"/>
            </LayoutSmall>
        </LayoutSmall>
    );
};
